// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-title-container[data-v-4be6b43f]{padding:1.5rem 1.5rem 1rem;display:flex;justify-content:space-between;background-color:#fff;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:1px solid #ebebeb}.modal-body[data-v-4be6b43f]{background-color:#fff}.modal-with-title-bar .close-circle-icon[data-v-4be6b43f]{cursor:pointer;color:rgba(10,10,10,.2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
